module.exports = __webpack_public_path__ + "static/media/ulolselect.a6b7bdf2.png";